import { render, staticRenderFns } from "./x-address-select.vue?vue&type=template&id=1326db75"
import script from "./x-address-select.vue?vue&type=script&lang=ts"
export * from "./x-address-select.vue?vue&type=script&lang=ts"
import style0 from "./x-address-select.vue?vue&type=style&index=0&id=1326db75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports